import React, { Component, Suspense, lazy } from 'react';
import { ConfigProvider } from 'antd';
import { Route, Redirect, Switch } from 'react-router-dom';
import PrivateRoute from '../routes/PrivateRoute';
import PrivateAdminRoute from '../routes/PrivateAdminRoute';
import PageConstant, { getPageNameFromPath } from '../constants/PageConstant';
import queryString from 'query-string';
import { store, persistor } from '../../shared/ConfigureStore';
import { MuiThemeProvider, createTheme  } from '@material-ui/core/styles';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import AuthConstants from '../constants/AuthActions';
import AuthActions from "../../actions/Auth";
import CodeConstant from '../constants/CodeConstant';
import jwt from 'jsonwebtoken';
import axios from 'axios';
import * as service from '../services/Auth';
import * as utils from '../services/Common';
import * as accountService from '../services/Dashboard';
import { isMobile } from 'react-device-detect';
import { pushLog2DV2LogServer, setIdentity } from '../services/logging';
import history from '../services/history';
import PropTypes from 'prop-types';
import moment from 'moment';
import { addChatbotWidget } from '../legacy_components/util/chatbot';
import RoleActions, { checkIfRoleCan } from '../constants/RoleActions';
import { AdminRoutesWithRole } from '../constants/AdminRoutesWithRole';
// import VettingTuringChat from '../legacy_components/UI_V2_Components/TuringChat/TuringChat';
import { turingLogger } from '../shared/TuringLogger';
// BaseWebDesign 13 Import
import {Client as Styletron} from 'styletron-engine-monolithic';
import {Provider as StyletronProvider} from 'styletron-react';
import { BaseProvider } from 'baseui';
import { customBaseUiTheme } from './customBaseUiTheme';

const LoginContainer = lazy(() => import('../containers/Auth/LoginContainer'));
const SignupContainer = lazy(() => import('../containers/Auth/SignupContainer'));
const DirectApplyContainer = lazy(() => import('../containers/DirectApply/DirectApplyContainer'));
const ForgotPassContainer = lazy(() => import('../containers/Auth/ForgotPassContainer'));
const SentEmailContainer = lazy(() => import('../containers/Auth/SentEmailContainer'));
const ResetPassContainer = lazy(() => import('../containers/Auth/ResetPassContainer'));
const AdminLoginContainer = lazy(() => import('../containers/AdminPanel/LoginContainer'));
const ExternalSourcingContainer = lazy(() => import('../containers/ExternalSourcing/ExternalSourcingContainer'));
const ThankYou = lazy(() => import('../legacy_components/UI_V2_Components/thankYou/ThankYou'));
const LCIReplay = lazy(() => import('../legacy_components/UI_V2_Components/LCIReplay'));
const RemoteExperienceContainer = lazy(() => import('../containers/Submit/RemoteExperienceContainer'));
const EnglishExperienceContainer = lazy(() => import('../containers/Submit/EnglishExperienceContainer'));
const PracticeCC = lazy(() => import('../legacy_components/UI_V2_Components/CodingChallenge/practiceCodingChallenge'));
const AutomatedCC = lazy(() => import('../legacy_components/UI_V2_Components/CodingChallenge/automatedCodingChallenge'));
const TakeChallenge = lazy(() => import('../legacy_components/components/public/takeChallenge'));
const ReferralLanding = lazy(() => import('../legacy_components/UI_V2_Components/Referral/ReferralLanding'));
const ThankPageContainer = lazy(() => import('../../containers/Submit/Test/ThankPageContainer'));
const OnboardingFlow = lazy(() => import('../legacy_components/UI_V2_Components/Onboarding'));

const DevProfile = lazy(() => import('../legacy_components/components/admin/devProfile/devProfile'));
const ScoreDetail = lazy(() => import('../legacy_components/components/admin/DV2ChallengeScore/ScoreDetail'));
const PreviewProblem = lazy(() => import('../legacy_components/components/admin/previewProblem'));
const ServerStatus = lazy(() => import('../legacy_components/components/admin/serverStatus/serverStatus'));
const Profile = lazy(() => import('../legacy_components/UI_V2_Components/profile/Profile'));
const Goodbye = lazy(() => import('../legacy_components/UI_V2_Components/goodbye/goodbye'));
const HireFest = lazy(() => import('../legacy_components/UI_V2_Components/HireFest/HireFest'));
const Notifications = lazy(() => import('../components/Notifications/Notifications'));
const FastTrackDevelopersCreate = lazy(() => import('../legacy_components/components/admin/FastTrackDevelopers/FastTrackDevelopersCreate'));
const NPSThankYouPage = lazy(() => import('../components/NPSThankYou'));
const JobLandingPage = lazy(() => import('../containers/JobLandingPage/JobLandingPageContainer'));

/* DON'T LAZY LOAD THIS, IT WILL BE DUPLICATES MULTIPLE TIMES */
import DashboardContainer from '../containers/Dashboard/DashboardContainer';
import AdminPanelContainer from '../containers/AdminPanel/AdminPanelContainer';
import VetsmithContainer from '../containers/Dashboard/VetsmithContainer';
import JobVetsmith from '../containers/Dashboard/JobVetsmithContainer';
import LiveCodeAdminContainer from '../legacy_components/LiveCodeInterview/admin';
import Vetsmith from '../legacy_components/UI_V2_Components/Vetsmith/Vetsmith';
import { NotificationsActions } from '../components/Notifications/Notifications.reducer';
import { logLoadTime } from '../services/util/PageLoad';
import fullStoryIdentify from '../../services/fullstory';
import { GB_FLAGS, withLDFlagsFromBackend } from '../legacy_components/services/launchDarkly';
import clarityIdentify from '../../services/clarity';
import canAccessPage from '../legacy_components/constants/canAccessPage';

import DevRateUpdateContainer from '../../v3/components/DevRateUpdate';
import { saveMobileBlockerVisitInfo } from './saveMobileBlockerVisitInfo';
import BrowserWarning from '../components/BrowserWarning';
import CookieConsent from "../components/CookieConsentBanner/CookieConsentBanner";
import { PLACEMENT, ToasterContainer } from 'baseui/toast';
import { checkJWTExpiration } from '../legacy_components/util/checkJWTExpiration';

axios.interceptors.request.use(config => {
    // Modify the request config here
    config.headers['currentUrl'] = window.location.href;
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken && window.location.href.includes('admin')) config.headers['Authorization'] = adminToken;
    return config;
}, error => {
    // Handle request error
    return Promise.reject(error);
});


function logOutUser() {
    if (!window.location.href.includes('/admin/')) 
    store.dispatch(AuthActions.logOut);
}

/* INTERCEPT UN-AUTHORIZE */
axios.interceptors.response.use(response => {
    if (response && response.data && response.data.code && response.data.code === CodeConstant.UNAUTHORIZED) {
        logOutUser(response);
    }
    return response;
  }, error => {
    if (error && error.response && error.response.data && error.response.data.code && error.response.data.code === CodeConstant.UNAUTHORIZED) {
        logOutUser(error.response);
    }
    return Promise.reject(error);
});

const engine = new Styletron();
/**
 * Customize default palette primary color and set for upgrading typography
 */
 const theme = createTheme({
    typography: {
      useNextVariants: true
    },
    palette: {
      primary: {
        light: '#4dabf5',
        main: '#2196f3',
        dark: '#1769aa',
        contrastText: '#fff'
      }
    }
});

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../../reducers', () => {
      const nextRootReducer = require('../../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }


class App extends Component {

    constructor (props) {
        super(props);
        this.state = {
          redirect: false,
          checkingRedirect: true
        };

        this.initialize();
    }

    initialize =  async () => {
        const url = window.location.search;
        const vetsmith_redirect_path = localStorage.getItem("vetsmith_redirect_path");
        if (!vetsmith_redirect_path) localStorage.setItem("vetsmith_redirect_path", window.location.pathname);
        const params = queryString.parse(url);
        // store.dispatch({ type: AuthConstants.SHOW_MAX_NUM_AND_SURVEY, payload: ['AFD61','AFD64','ZFD20200106'].includes(params.s) && params.n });
        /* UPDATE 22nd OCT.: SHOW SURVEY FOR ALL ADS WITH s PARAMS START WITH: ads_developers */
        store.dispatch({ type: AuthConstants.SHOW_MAX_NUM_AND_SURVEY, payload: params.s && params.s.startsWith('ads_developers') && params.n });
        store.dispatch({ type: AuthConstants.TOKEN_EXPIRED, payload: { token_expired: false } });

        const token = params && params.token;
        const isTokenExpired = checkJWTExpiration(token);
        if (token && !isTokenExpired) {
          const user = jwt.decode(token);
          if (user) {
            if (user.isEmbed) {
              // override localStorage.setItem
              window.localStorage.setItem = (function (_super) {
                return function () {
                  window.embedData = window.embedData || {};
                  window.embedData[arguments[0]] = arguments[1];
                };
              })(window.localStorage.setItem);

              // override localStorage.getItem
              window.localStorage.getItem = (function (_super) {
                return function () {
                  if (window.embedData && arguments[0] in window.embedData) {
                    return window.embedData[arguments[0]];
                  }
                };
              })(window.localStorage.getItem);
            } else {
              const redirectUrlForLocalStorage = localStorage.getItem('redirect_url');
              const jobOpportunityCode = localStorage.getItem('jobCode');
              const directJobApplicationReferrer = localStorage.getItem('directJobApplicationReferrer');
              const directJobApplicationNotificationChannel = localStorage.getItem('directJobApplicationNotificationChannel');
              const developerSource = localStorage.getItem('developerSource');
              localStorage.clear();

              localStorage.setItem('redirect_url', params.redirect || redirectUrlForLocalStorage);
              localStorage.setItem('jobCode',  jobOpportunityCode || params.jobCode);
              localStorage.setItem('directJobApplicationReferrer', directJobApplicationReferrer);
              localStorage.setItem('directJobApplicationNotificationChannel', directJobApplicationNotificationChannel);
              localStorage.setItem('developerSource', developerSource);
            }
            // Save token
            localStorage.setItem('userFullName', user.name);
            localStorage.setItem('userEmail', user.email);
            localStorage.setItem('token', token);
            localStorage.setItem('landing', user.isEmbed ? 'false' : 'true');
            localStorage.setItem('isEmbed', user.isEmbed ? 'true' : 'false');
            localStorage.setItem('isReadOnly', user.readOnly ? 'true' : 'false');
            localStorage.setItem('partnerLogoId', user.logoId);
            localStorage.setItem('authenticated', 'true');
            if (user.accountByResume) {
              localStorage.setItem('lastStep', 2);
            }
            fullStoryIdentify();
            clarityIdentify();
            store.dispatch({ type: AuthConstants.AUTHENTICATE, payload: { authenticated: true } });

            const entranceData = utils.getUserEntranceInformation('login')
            service.saveUserEntranceInfo(entranceData)

            const redirectUrl = localStorage.getItem('redirect_url');
            const noRedirectUrl = redirectUrl === 'null' || !redirectUrl;
            if (user.custom_flow_id && noRedirectUrl) {
                localStorage.setItem('vetsmith_token', 'true');
                localStorage.setItem("redirected_to_vetsmith", "true");
                window.location = PageConstant.VETSMITH_PAGE;
            }
          }
        } else {
          const isEmbed = localStorage.getItem('isEmbed');
          if (isEmbed === 'true') {
            localStorage.clear();
          }
        }

        const ref = params.ref;
        if (ref) {
            localStorage.setItem('ref', ref);
            if (params.tempId) localStorage.setItem('tempId', params.tempId);
            if (params.email) localStorage.setItem('ref_email', params.email);
        }
        /**
         * Check new user flag and flagTime for home page welcome
         */
        const flagDate = localStorage.getItem('flagTime');
        if (flagDate && moment().diff(moment(flagDate), 'hours') >= 24) {
            localStorage.removeItem('flagTime');
            localStorage.removeItem('flagNewUser');
        }
        this._history = (this.props.history || history);
        await saveMobileBlockerVisitInfo();
    }

    /**
    * Get account info when component mount to check if user has password or not
    */
    getAccountInfo = () => {
        const promiseObj = accountService.getAccountInfo();
        return promiseObj.then(res => {
        if (res.data.code === CodeConstant.OK || res.data.code === CodeConstant.BAD_REQUEST) {
            if (res.data.data && this.dispatch) {
                this.dispatch({ type: NotificationsActions.SET_NOTIFICATIONS, payload: res.data.data.notifications });
            }
            return res.data.data.accountData;
        } else if (res.data.code === CodeConstant.UNAUTHORIZED) {
            this.setState({
            openDialogoption: true
            });
            return {};
        }
        return {};
        }).catch(error => {
        console.log(error);
        });
    }

    UNSAFE_componentWillMount () {

        const authenticated = localStorage.getItem('authenticated');
        if (typeof authenticated === 'undefined' || authenticated === null) {
            localStorage.setItem('authenticated', false);
        }

        const adminAuthenticated = localStorage.getItem('adminAuthenticated');
        if (typeof adminAuthenticated === 'undefined' || adminAuthenticated === null) {
            localStorage.setItem('adminAuthenticated', false);
        }

        const token = localStorage.getItem('token');
        if (token) {
            /* IDENTIFY SEGMENT.IO */
            /* THE CURRENT APP ONLY EXPOSE email */
            const email = localStorage.getItem('userEmail'); // get first time user email in localStorage

            const user = jwt.decode(token);
            if (!user) {
                localStorage.clear();
                return;
            }
            if (!user.email) user.email = email; /* WHEN USER FIRST VISIT, THERE WILL BE NO EMAIl, NAME BUT TOKEN STILL EXISTS */

            if (user.uid && window.analytics) {
                window.analytics.identify(user.uid, {
                url: window.location.href,
                email: user.email
                });
            }
            // setFullUserStory(user);
        }

        this.setViewPort();

        localStorage.setItem('checkAnnouncementCalled', false);
    }

    componentDidMount () {
        logLoadTime();
        this.checkAuth();

        /* Register listener */
        this.unlistenHistory = this._history.listen(this.onRouteChange);
        /* Add chatbot widget */
        addChatbotWidget(() => { this.setChatboxVisibility(); }, true);
        /* First load */
        this.onRouteChange(this._history.location, this._history.action);

        turingLogger.registerActivityTracker();
    }

    setChatboxVisibility = () => {
        const { pathname } = this._history.location;
        const isEmbed = localStorage.getItem('isEmbed');
        const chatbot = document.getElementById("hubspot-conversations-iframe");
        if (chatbot) {
            if (isEmbed === 'true' || ['/','/signup', '/login'].indexOf(pathname) > -1) {
                chatbot.setAttribute("style", "display: none !important;")
            } else {
                chatbot.setAttribute("style", "")
            }
        }
    }

    onRouteChange = (location, action) => {
        const { pathname, search, hash } = location;
        /** Need to remove token from the search since its part of relativeURL sent to DB */
        const searchWithoutToken = (search || '').split('&').filter(p => !p.includes('token')).join('&');
        const relativeUrl = `${pathname}${searchWithoutToken}${hash}`;
        let adsDevelopersParams = {};
        if (search) {
        location._search = searchWithoutToken.startsWith('?') ? searchWithoutToken.replace(/\?/, '') : searchWithoutToken;
        adsDevelopersParams = location._search
            .split('&')
            .map(param => param.split('='))
            .reduce((obj, [key, val]) => { obj[key] = val; return obj; }, {});
        /* If exists the s param with a value "ads_developer..." then store the params */
        adsDevelopersParams = adsDevelopersParams.s && adsDevelopersParams.s.startsWith('ads_developers') ? adsDevelopersParams : {};
        }

        const pageName = getPageNameFromPath(pathname);
        if (pageName) {
            pushLog2DV2LogServer.info('PAGE_VIEW', `PAGE_${pageName}`, { ...adsDevelopersParams }, { ...adsDevelopersParams, relativeUrl }, null);
        } else {
            pushLog2DV2LogServer.info('USER_LOGGING', 'PAGE_VIEW', { ...adsDevelopersParams }, { ...adsDevelopersParams, relativeUrl }, null);
        }

        /* Check the route and hide chatbox widget if loaded */
        this.setChatboxVisibility();

        turingLogger.pageview().catch(e => console.error(e));
    };

    componentWillUnmount () {
        this.unlistenHistory();
    }

    setViewPort = () => {
        if (isMobile && window.screen.width < 1024) {
        document.querySelector('meta[name=viewport]').setAttribute(
            'content',
            'width=device-width, initial-scale=0.8, shrink-to-fit=no');
        }
    };

    /**
     * Check auth token
     */
    checkAuth = async () => {
        /* 24th SEPT. DONT DO THE AUTO REDIRECT IF THIS IS THE SPECIAL PAGE */
        const bypassAuthRedirectPath = [ '/lci_embed/play', '/embed/profile' ];
        if(bypassAuthRedirectPath.includes(window.location.pathname)) return;

        let accountData = null;
        const token = localStorage.getItem('token');
        // Only call this API to check for account info if user is not already in the account page
        // To prevent duplicate call since it will also be called on the account page
        // Calling to check redirect
        // if (token && window.location.pathname !== PageConstant.ACCOUNT) {
        //     accountData = await this.getAccountInfo();
        //     // Check if there is token and the account data contains email and password
        //     if (accountData && 'accountExist' in accountData && accountData.accountExist === 'false') {
        //         localStorage.clear();
        //         utils.redirectPage(PageConstant.SIGNUP);
        //         return;
        //     }
        //     if (accountData && (!accountData.email || accountData.email === '' || (!accountData.ssoAuth && !accountData.passwordExist)) &&
        //         window.location.pathname !== PageConstant.PROFILE_ONBOARDING) {
        //         utils.redirectPage(PageConstant.ACCOUNT);
        //         return;
        //     }
        // }

        const urlParams = queryString.parse(window.location.search);
        if ((urlParams.token) && (urlParams.type)) {
            const mailToken = urlParams.token;
            const type = urlParams.type;
            const templateName = urlParams.template;

            // verify token and redirect uncompleted page
            if (window.location.pathname === PageConstant.TOLANDINGPAGE || window.location.pathname === PageConstant.TOLOGIN || window.location.pathname === PageConstant.TOLOGIN + '/') {
                const templateInfo = {
                    templateName: templateName
                };
                this.GetRedirectUrlFromMailToken(mailToken, type, templateInfo);
            }
        } else {
            // const token = localStorage.getItem('token');
            const landing = localStorage.getItem('landing');
            // if ((token) && (landing) && (landing === 'true')) {
                // localStorage.setItem('authenticated', true);
                // if (window.location.pathname === PageConstant.TOLANDINGPAGE ||
                //     window.location.pathname === PageConstant.TOLOGIN ||
                //     window.location.pathname === PageConstant.TOLOGIN + '/' ||
                //     window.location.pathname === PageConstant.TOSIGNUP ||
                //     window.location.pathname === PageConstant.TOSIGNUP + '/') {
                //     this.ajaxGetRedirectUrl(token);
                // }
                /*
                (Fix VET2-635) After creating a new account we have landing != 'true'
                then the else block will be executed
                (when we navigate using history.push or <Link /> this script will
                    not be executed because the <App/> already mounted but the first time when we reload the page
                    the logged user will be logout)
                */
                // } else {
                //   localStorage.setItem('authenticated', false)
            // }
        }

        /* REDIRECTING LOGIC */
        // const hasRef = localStorage.getItem('ref');
        // let profileCompleted;
        // let showRefLanding;
        // if (token) {
        //     const [checkProfile, checkReferral] = await Promise.all([checkProfileStatus(), checkReferralInfos()]);
        //     profileCompleted = get(['data', 'result', 0, 'result'], checkProfile);
        //     /** Set profile completed value to localstorage,
        //      * Need to set this to know if user already completed profile before setting new completed
        //      * flag=true in localstorage
        //      */
        //     if (profileCompleted) {
        //         localStorage.setItem('profileCompleted', 'true');
        //     }
        //     showRefLanding = checkReferral.showLanding;
        // }

        // /* 1.REFERRAL USER - NOT INVITED ENOUGH 3 EMAILS */
        // if (showRefLanding) {
        //     if (window.location.pathname !== PageConstant.REFERRAL_LANDING) redirector.to(PageConstant.REFERRAL_LANDING);
        //     this.setState({ checkingRedirect: false });
        //     return;
        // }

        /* 2.NOT REFERRAL USER - OR REFERRAL USER ALREADY INVITE 3 EMAILS */
        // /* 2.1 HAS REF NO TOKEN */
        // if (hasRef && !token) {
        //     if (window.location.pathname !== PageConstant.SIGNUP) redirector.to(PageConstant.SIGNUP);
        //     this.setState({ checkingRedirect: false });
        //     return;
        // }

        // // let targetPage = PageConstant.PROFILE_ONBOARDING;
        // // const isHireFestToken = localStorage.getItem('hire_fest_token');
        // // if (isHireFestToken === 'true') {
        // //   targetPage = PageConstant.HIREFEST_PAGE;
        // // }

        // // /* 2.2 HAS REF AND TOKEN */
        // // if (hasRef) {
        // //     /* PROFILE NOT COMPLETED */
        // //     if (!profileCompleted && window.location.pathname !== PageConstant.PROFILE_ONBOARDING && window.location.pathname !== PageConstant.HIREFEST_PAGE && window.location.pathname !== PageConstant.VETSMITH_PAGE) redirector.to(targetPage);
        // //     this.setState({ checkingRedirect: false });
        // //     return;
        // // }

        // // /* 2.3 NO REF AND GOT TOKEN */
        // // if (token && !profileCompleted && window.location.pathname !== PageConstant.PROFILE_ONBOARDING && window.location.pathname !== PageConstant.HIREFEST_PAGE && window.location.pathname !== PageConstant.VETSMITH_PAGE) redirector.to(targetPage);

        /* DO NOTHING FOR OTHER CASES */
        // this.setState({ checkingRedirect: false });
    }

    /**
     * Ajax function for getting uncompleted page url
     */
    // ajaxGetRedirectUrl = async (token) => {
    //     const ret = await service.getRedirectUrl(token);
    //     if (ret.data.code === CodeConstant.OK || ret.data.code === CodeConstant.CREATED) {
    //     /* LOGGING IDENTITY */
    //     const user = jwt.decode(token);
    //     setIdentity({ ...user, user_id: user.uid });
    //     pushLog2DV2LogServer.info('SIGN_IN', 'SIGN_IN_EMAIL', user, {}, null);
    //     let targetPage = PageConstant.PROFILE_ONBOARDING;
    //     const isHireFestToken = localStorage.getItem('hire_fest_token');
    //     if (isHireFestToken === 'true') {
    //       targetPage = PageConstant.HIREFEST_PAGE;
    //     }

    //     /* legacy_components - Changes: redirect to URL if available */
    //     const url = new URL(window.location.href);
    //     let redirect = url.searchParams ? url.searchParams.get('redirect') : null;
    //     if (redirect) {
    //         const redirect2SignupOrLogin = redirect.includes('signup') || redirect.includes('login');
    //         redirector.to(targetPage, redirect2SignupOrLogin ? null : redirect);
    //     } else {
    //         redirect = get(['data', 'data', 'url'], ret);
    //         if (redirect) {
    //         const redirect2SignupOrLogin = redirect.includes('signup') || redirect.includes('login');
    //         redirector.to(targetPage, redirect2SignupOrLogin ? null : redirect);
    //         } else {
    //         localStorage.setItem('landing', false);
    //         redirector.to(targetPage);
    //         }
    //     }
    //     /* End legacy_components */
    //     } else {
    //         console.log(ret.data.message);
    //     }
    // }

    /**
     * Ajax function for getting uncompleted page url
     */
    GetRedirectUrlFromMailToken = async (mailToken, type, templateInfo) => {
        const ret = await service.getRedirectUrlFromMailToken(mailToken, type, templateInfo);

        if (ret.data.code === CodeConstant.OK || ret.data.code === CodeConstant.CREATED) {
        // save token
        localStorage.setItem('token', ret.data.data.token);
        localStorage.setItem('landing', ret.data.data.landing);
        fullStoryIdentify();
        clarityIdentify();
        /* LOGGING IDENTITY */
        const user = jwt.decode(token);
        setIdentity({ ...user, user_id: user.uid });
        pushLog2DV2LogServer.info('SIGN_IN', 'AUTO_SIGN_IN_WITH_EMAIL_TOKEN', user, {}, null);

        if (ret.data.data.url !== '') {
            localStorage.setItem('authenticated', true);
            utils.redirectPage(ret.data.data.url);
        } else {
            localStorage.setItem('authenticated', false);
            localStorage.setItem('landing', false);
        }
        } else {
        console.log(ret.data.message);
        }
    }

    /**
   * Render function to view this component
   */

    render() {
        const adminAuthenticated = localStorage.getItem('adminAuthenticated');
        const authenticated = localStorage.getItem('authenticated');
        const token = localStorage.getItem('token');
        const isEmbed = localStorage.getItem('isEmbed');
        const isReadOnly = localStorage.getItem('isReadOnly');
        const partnerLogoId = parseInt(localStorage.getItem('partnerLogoId'));
        const showNotifications = this.props.LDFlags && this.props.LDFlags.gb_notification_feature;
        const jobsPageEnabled = true;
        const state = store.getState();

        let devStatusObj = {};
        if (state && state.home) {
            const statusData = state.home || {};
            const testData = state.tests || {};
            devStatusObj = {
                cloudRoleIds: statusData.cloudRoleIds,
                techInterviewCheck: statusData.techInterviewCheck,
                status: statusData.devStatus,
                isProgrammerRole: statusData.isProgrammerRole,
                extraPassedInfo: statusData.extraPassedInfo || {},
                turingProfileCompleted: testData.turingProfileCompleted,
                hasFastrack: state.jobs && state.jobs.fastrack ? state.jobs.fastrack.length > 0 : false,
                jobsPageEnabled,
                coreSkillPassed: statusData.coreSkillPassed,
                flags: this.props.LDFlags,
                workExpCompleted: statusData.workExpCompleted,
                passedAdditionalMCQ: testData.passedAdditionalMCQ,
                showCoreQuiz: (testData.core_challenges || []).length > 0
            }
        }

        let firstAllowedAdminRoot = null;
        if (adminAuthenticated) {
            firstAllowedAdminRoot = AdminRoutesWithRole.find(item => !item.roleAction || checkIfRoleCan(item.roleAction));
        }

        if (isEmbed === 'true') {
            return (
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <MuiThemeProvider theme={theme}>
                            <StyletronProvider value={engine}>
                                <BaseProvider theme={customBaseUiTheme}>
                                    <Suspense fallback={<div className='lds-ripple'><div></div></div>}>
                                        <Switch>
                                            <PrivateRoute exact path="/embed/profile" allowInMobile isEmbed={true} isReadOnly={isReadOnly === 'true'} partnerLogoId={partnerLogoId} component={Profile} authenticated={authenticated} />
                                            <Redirect to='/embed/profile' />
                                        </Switch>
                                    </Suspense>
                                </BaseProvider>
                            </StyletronProvider>
                        </MuiThemeProvider>
                    </PersistGate>
                </Provider>
            );
        }

        return (
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    {/* {process.env.REACT_APP_ENABLE_EXPERIMENTAL_CHAT_APP && <VettingTuringChat />} */}
                    <MuiThemeProvider theme={theme}>
                        <ConfigProvider theme={{
                            primaryColor: '#1890ff',
                            errorColor: '#ff4d4f',
                            warningColor: '#faad14',
                            successColor: '#52c41a',
                            infoColor: '#1890ff',
                        }}>
                            <StyletronProvider value={engine}>
                                <BaseProvider theme={customBaseUiTheme}>
                                    <ToasterContainer placement={PLACEMENT.topRight} autoHideDuration={3000} overrides={{
                                        Root: {
                                            style: () => ({
                                                zIndex: 9999,
                                            })
                                        }
                                    }} />
                                    <Suspense fallback={<div className='lds-ripple'><div></div></div>}>
                                        {showNotifications && <Notifications />}
                                        <BrowserWarning />
                                        <Switch>
                                            {/* ANONYMOUS */}
                                            <Route exact path="/login" component={LoginContainer} />
                                            <Route exact path="/signup" component={SignupContainer} />
                                            <Route exact path="/invite/:token" component={ExternalSourcingContainer} />
                                            <Route exact path="/job/home" component={JobLandingPage} />
                                            <Route exact path="/login/forgot_pass" component={ForgotPassContainer} />
                                            <Route exact path="/login/sent_email" component={SentEmailContainer} />
                                            <Route exact path="/login/reset_pass" component={ResetPassContainer} />
                                            <Route exact path="/admin/login" component={AdminLoginContainer} />
                                            <Route exact path="/thank-you" component={ThankYou} />
                                            <Route exact path="/thank-you-nps" component={NPSThankYouPage} />
                                            <Route exact path="/goodbye" component={Goodbye} />
                                            <Route path="/embed" component={args => <p>Access not allowed</p>} />
                                            <Route exact path="/lci_embed/play" component={LCIReplay} /* YES, IT'S PUBLIC. ANY LINK WITH TOKEN IN URL WORKS */ />

                                            {/* LOGGED IN USER */}
                                            <PrivateRoute path="/direct-apply" allowInMobile component={DirectApplyContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path="/submit/remote_experience" allowInMobile component={RemoteExperienceContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path="/submit/english_experience" allowInMobile component={EnglishExperienceContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path="/dashboard/turing_community" allowInMobile component={DashboardContainer} authenticated={authenticated} />

                                            <PrivateRoute exact path="/dashboard/practice" component={PracticeCC} authenticated={authenticated} />
                                            <PrivateRoute exact path="/dashboard/coding" component={AutomatedCC} authenticated={authenticated} />
                                            <PrivateRoute exact path="/dashboard/takechallenge" component={TakeChallenge} authenticated={authenticated} />
                                            <PrivateRoute exact path={PageConstant.REFERRAL_LANDING} allowInMobile component={ReferralLanding} authenticated={authenticated} />
                                            <PrivateRoute exact path="/submit/thank" allowInMobile component={ThankPageContainer} authenticated={authenticated} />
                                                    <PrivateRoute exact path={PageConstant.PROFILE_ONBOARDING} allowInMobile component={OnboardingFlow} authenticated={authenticated} />

                                            <PrivateRoute path={PageConstant.NEW_PROFILE_PAGE} allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path="/dashboard/profile" allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path="/dashboard/home" allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path="/dashboard/account" allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact canAccessPage={() => canAccessPage('coding_challenge', devStatusObj)} redirectPath="/dashboard/home" path="/dashboard/coding_challenge" allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path="/dashboard/finalize_my_resume" allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path={PageConstant.GET_MATCHED} allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            {/* <PrivateRoute exact canAccessPage={() => canAccessPage('jobs', devStatusObj)} redirectPath="/dashboard/home" path={PageConstant.JOB_PAGE} allowInMobile component={DashboardContainer} authenticated={authenticated} /> */}
                                            <PrivateRoute exact canAccessPage={() => canAccessPage('job', devStatusObj)}  redirectPath="/dashboard/home" path={PageConstant.JOB_PAGE} allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact redirectPath="/dashboard/home" path={PageConstant.RECOMMENDED_JOBS_PAGE} allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact redirectPath="/dashboard/home" path={PageConstant.APPLIED_JOBS_PAGE} allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path="/dashboard/referral" allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact canAccessPage={() => canAccessPage('turing_test', devStatusObj)} path="/dashboard/turing_test" allowInMobile component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute path="/dashboard/turing_test/:challengeName/:challengeId" component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute path={PageConstant.FAST_TRACK_PAGE} component={DashboardContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path="/HireFest" allowInMobile component={HireFest} authenticated={authenticated} />
                                            <PrivateRoute exact path={PageConstant.VETSMITH_PAGE} component={VetsmithContainer} authenticated={authenticated} />
                                            <PrivateRoute exact path="/dashboard/jobs/:jobId/specialized-vetting" component={JobVetsmith} authenticated={authenticated} />


                                            <PrivateRoute path={PageConstant.DEV_RATE_UPDATE} allowInMobile authenticated={authenticated} component={DevRateUpdateContainer} />
                                            <PrivateRoute exact redirectPath="/dashboard/home" path={PageConstant.SOFT_SKILLS} allowInMobile authenticated={authenticated} component={DashboardContainer} />


                                            {/* LOGGED IN ADMIN */}
                                            <PrivateAdminRoute exact path="/admin/devProfile/:devId" component={DevProfile} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.DV2_CHALLENGE_SCORE} path="/admin/scoreDetail/:submitId" component={ScoreDetail} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.ALL_PROBLEMS} path="/admin/previewProblem/:problemId" component={PreviewProblem} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute path="/admin/status" component={ServerStatus} authenticated={adminAuthenticated} />

                                            <PrivateAdminRoute checkRoleAction={RoleActions.DASHBOARD} exact path="/admin/dashboard" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.ALL_CHALLENGES} exact path="/admin/dv2_challenge_list" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.PROBLEM_EDITOR} path="/admin/problemEditor/:problemId" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.ALL_PROBLEMS} exact path="/admin/problems" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.ALL_CHALLENGES} path="/admin/dv2-challenge-score/:challengeName/:challengeId" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.DV2_CHALLENGE_SCORE} exact path="/admin/dv2-challenge-score" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.CHALLENGE_EDITOR} exact path="/admin/challengeEditor" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.JOB_EDITOR} exact path="/admin/jobEditor" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.JOB_LIST} exact path="/admin/jobList" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.JOB_APPLY_LIST} exact path="/admin/jobApplyList" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.MCQ_SCORE_SUMMARY} path="/admin/mcqScoreSummary" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.BUG_REPORT_LIST} path="/admin/bugReport" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.QA_ACCOUNTS_LIST} path="/admin/qaAccount" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.CHALLENGE_STATISTICS} path="/admin/challengeStatistics" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.RESET_CANDIDATE_TEST} path="/admin/resetCandidateTest" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.UPDATE_DEVELOPER_SENIORITY} path="/admin/updateSeniority" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.SETUP_MCQ_ROLE_PREFERED} path="/admin/mcqStatusUpdate" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.SETUP_LABEL_AREA_RELATIONSHIP} path="/admin/areaRelationship" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.MCQ_SURVEY} path="/admin/mcqSurvey" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.UPDATE_MCQ_SCORE} path="/admin/updateMCQScore" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.CHALLENGE_AB_TEST_CONFIGURATION} path="/admin/challengeABTestConfig" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.MCQ_COPY_EDITOR} path="/admin/mcqCopyEditor" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.LOGIN_AS_USER} path="/admin/impersonateUser" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.DELETE_USER} path="/admin/delete-user-account" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.SETUP_STACK_DEMAND} path="/admin/setupStackDemand" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.INTERVIEW_ELIGIBILITY} path="/admin/interviewEligibility" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.UPDATE_CANDIDATES_STATUS} path="/admin/updateCandidatesStatus" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.LIVE_CODE_INTERVIEW} path="/admin/live/setup" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.LIVE_CODE_INTERVIEW} path="/admin/live/:page" component={LiveCodeAdminContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.USER_PROFILE_VIEW} path="/admin/programming-languages" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.ACCOUNT_MANAGEMENT} path="/admin/account-management" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.CHANGE_CANDIDATE_EMAIL} path="/admin/change-candidate-email" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.ADMIN_LIST_BOOKED_EVENT} path="/admin/booked-event" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.ADMIN_CALENDAR_SETUP} path="/admin/calendar/setup/:calId" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.ADMIN_LIST_CALENDARS} path="/admin/calendar/list" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute path="/admin/change-password" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.SETUP_AVAILABILITY} path="/admin/setupAvailability" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.INTERVIEWER_AVAILABILITY_REPORT} path="/admin/interviewer-availability" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.INTERVIEWER_PERFORMANCE_REPORT} path="/admin/interviewer-performance" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.USER_PROFILE_VIEW} path="/admin/user-profile-view" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.CREATE_ACCOUNT_BY_RESUME} path="/admin/create-account-by-resume" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.CREATE_ACCOUNT_BY_RESUME} path="/admin/create-accounts" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.S_PARAM_MANAGEMENT} path="/admin/s-param-management" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.USER_PROFILE_VIEW} path="/admin/display-mcq-questions" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.SETUP_SKILL_RELATIONSHIP} path="/admin/setup-skill-relationship" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.SETUP_SKILL_MCQ_RELATIONSHIP} path="/admin/setup-skill-mcq-relationship" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.SETUP_DEMAND_STACK_SKILL} path="/admin/setup-demand-stack-skill" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.JOB_SEARCH} path="/admin/job_search" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={null} path="/admin/referral-statistics" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.CREATE_TEST_ACCOUNT} path="/admin/create-test-account" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={null} path="/admin/cms" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={null} path="/admin/recommendation" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute checkRoleAction={RoleActions.VETSMITH} path="/admin/customized-vetting" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute path="/admin/search-acc-video" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute path="/admin/cloud-certification-verification" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute path="/admin/cloud-certificates" component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute exact path="/admin/ci-labs-profiles" checkRoleAction={RoleActions.CLOUD_INSTITUTE} component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute exact path="/admin/ci-labs-instances" checkRoleAction={RoleActions.CLOUD_INSTITUTE} component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute exact path="/admin/fast-track-developers" checkRoleAction={RoleActions.LOGIN_AS_USER} component={AdminPanelContainer} authenticated={adminAuthenticated} />
                                            <PrivateAdminRoute exact path="/admin/fast-track-developers/create" checkRoleAction={RoleActions.LOGIN_AS_USER} component={FastTrackDevelopersCreate} authenticated={adminAuthenticated} />
                                            {firstAllowedAdminRoot ? (<Redirect from='/admin' to={firstAllowedAdminRoot.path} />) : null}
                                            {/* Redirect any unknown route to home page */}
                                            <Redirect to={PageConstant.DASHBOARD_DEV} />

                                        </Switch>
                                        <CookieConsent />
                                    </Suspense>
                                </BaseProvider>
                            </StyletronProvider>
                        </ConfigProvider>
                    </MuiThemeProvider>
                </PersistGate>
            </Provider>
        );
    }
}


App.propTypes = {
    history: PropTypes.any,
    LDFlags: PropTypes.object,
};

export default withLDFlagsFromBackend(App, [GB_FLAGS.gb_notification_feature, GB_FLAGS.enable_soft_skills, GB_FLAGS.use_role_based_mcq_uiux]);
